/* eslint-disable */
// Shared react-datepicker wrappers for the event forms (community + hosted).
// Values cross the API boundary as strings — "YYYY-MM-DD" and "HH:MM" — so
// these components translate to/from Date objects at the edge only.
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./dateTimePickers.css";

export function parseYmd(s) {
  if (!s) return null;
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function toYmd(d) {
  if (!d) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function parseHm(s) {
  if (!s) return null;
  const [h, m] = s.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d;
}

export function toHm(d) {
  if (!d) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getHours())}:${p(d.getMinutes())}`;
}

// "18:30" → "6:30 PM" for read-only rows.
export function fmtTime12(s) {
  const d = parseHm(s);
  if (!d) return s || "";
  return d.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true }).toUpperCase();
}

// Calendar popup; stores "YYYY-MM-DD", displays "dd MMM yyyy". Min date today.
export function FormDatePicker({ value, onChange, className, placeholder = "Pick a date" }) {
  return (
    <DatePicker
      selected={parseYmd(value)}
      onChange={(d) => onChange(d ? toYmd(d) : "")}
      minDate={new Date()}
      dateFormat="dd MMM yyyy"
      placeholderText={placeholder}
      className={className}
      wrapperClassName="vs-dp-wrap"
      autoComplete="off"
    />
  );
}

// Time-only popup, 15-minute steps; stores "HH:MM", displays "h:mm a".
export function FormTimePicker({ value, onChange, className, placeholder = "Pick a time" }) {
  return (
    <DatePicker
      selected={parseHm(value)}
      onChange={(d) => onChange(d ? toHm(d) : "")}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      timeCaption="Time"
      dateFormat="h:mm aa"
      placeholderText={placeholder}
      className={className}
      wrapperClassName="vs-dp-wrap"
      isClearable
      autoComplete="off"
    />
  );
}
